var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4791 5.09257C21.4936 5.30257 21.4936 5.51257 21.4936 5.7245C21.4936 12.1822 16.5774 19.63 7.58809 19.63V19.6261C4.93261 19.63 2.33229 18.8693 0.0968018 17.4351C0.482931 17.4816 0.870995 17.5048 1.26003 17.5058C3.46067 17.5077 5.59841 16.7693 7.3297 15.4097C5.23841 15.37 3.40454 14.0064 2.7639 12.0158C3.49648 12.1571 4.25132 12.128 4.97035 11.9316C2.69035 11.471 1.05003 9.46773 1.05003 7.14128C1.05003 7.11999 1.05003 7.09966 1.05003 7.07934C1.72938 7.45773 2.49003 7.66773 3.26809 7.69095C1.12067 6.25579 0.458737 3.39902 1.75551 1.16547C4.2368 4.2187 7.89777 6.07482 11.8278 6.27128C11.4339 4.57386 11.972 2.79515 13.2416 1.60192C15.21 -0.248401 18.3058 -0.153562 20.1562 1.81386C21.2507 1.59805 22.2997 1.19644 23.2597 0.627406C22.8949 1.7587 22.1313 2.71966 21.1113 3.33031C22.08 3.21612 23.0265 2.95676 23.9178 2.56095C23.2616 3.54418 22.4352 4.40063 21.4791 5.09257Z",
    fill: "#213051"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.01f39f9f3794eeb780c7492fdd797917.svg";
export { ForwardRef as ReactComponent };